// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2ZMR-","rootCenter":"LoadMoreObserver_rootCenter__1eg23","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1-nMu"};